import React, {createContext, useContext, useEffect, useMemo, useState} from 'react'
import PromptDebugDrawer                                                from './PromptDebugDrawer'
import {
	isPromptDebugEnabled,
	onPromptDebugChanged,
	setPromptDebugEnabled,
}                                                                       from '../../util/prompt-debug'

/*
 * Prompt debug mode (097).
 *
 * Two things live here: whether debug mode is on, and the one drawer that shows a capture. Mounted
 * once near the root so the toggle in the nav menu and the debug button on an AI message are
 * looking at the same switch, without threading props through the chat.
 *
 * The flag itself lives in localStorage (util/prompt-debug.js) because do-fetch.js has to read it
 * on every request and is not a component. This mirrors it into React state so the UI re-renders.
 */

const PromptDebugContext = createContext({
	enabled: false,
	setEnabled: () => {},
	openCapture: () => {},
})

const usePromptDebug = () => useContext(PromptDebugContext)

const PromptDebugProvider = ({children}) => {
	const [enabled, setEnabled] = useState(isPromptDebugEnabled())
	const [captureId, setCaptureId] = useState(null)

	useEffect(() => onPromptDebugChanged(() => setEnabled(isPromptDebugEnabled())), [])

	const value = useMemo(() => ({
		enabled: enabled,
		// writes localStorage; the change event above brings the state back in sync
		setEnabled: (next) => setPromptDebugEnabled(next),
		openCapture: (id) => setCaptureId(id || null),
	}), [enabled])

	return (
		<PromptDebugContext.Provider value={value}>
			{children}
			<PromptDebugDrawer captureId={captureId} onClose={() => setCaptureId(null)}/>
		</PromptDebugContext.Provider>
	)
}

export {PromptDebugProvider, usePromptDebug}
export default PromptDebugProvider
